import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { isEqual } from "lodash";
import React, { memo } from "react";
import ReactTooltip from "react-tooltip";
import { KEY_ENTER, KEY_SPACE, TOOLTIP_SHOW_DELAY } from "@config/constants";
var PrevButton = function(param) {
    var disabled = param.disabled, getButtonsData = param.getButtonsData, onClick = param.onClick;
    var onKeyDownHandler = function(e) {
        var key = e.which;
        if (key === KEY_SPACE || key === KEY_ENTER) {
            onClick();
            e.stopPropagation();
        }
    };
    var buttonsData = getButtonsData();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ReactTooltip, {
                id: "prev-button-tooltip",
                className: "tooltip",
                place: "bottom",
                delayShow: TOOLTIP_SHOW_DELAY,
                disable: disabled,
                effect: "solid",
                getContent: [
                    function() {
                        return buttonsData.prev.dataTip;
                    }
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "play-button player-button",
                onClick: onClick,
                onKeyDown: onKeyDownHandler,
                tabIndex: "0",
                "data-for": "prev-button-tooltip",
                "data-tip": buttonsData.prev.dataTip,
                children: /*#__PURE__*/ _jsx("span", {
                    className: "icon icon-skip-previous pointer"
                })
            })
        ]
    });
};
var areEqual = function(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
};
export default /*#__PURE__*/ memo(PrevButton, areEqual);
